angular.module('bmsApp.crm.customer').controller('CustomerSaveCtrl', function ($state,
																			   $scope,
																			   $q,
																			   $timeout,
																			   $filter,
																			   $uiViewScroll,
																			   $ngBootbox,
																			   notify,
																			   CustomerTypeSvc,
																			   CustomerStatusSvc,
																			   FormOptionsSvc,
																			   ContactDetailTypeSvc,
																			   CustomerGroupSvc,
																			   LicenseOptionsSvc,
																			   EnquirySvc,
																			   MMCustomerInactiveReasonSvc,
																			   TGCancelReasonSvc,
																			   CustomerSvc,
																			   SiteSvc,
																			   // MMJobSvc,
																			   TGJobSvc,
																			   InvoiceDeliveryMethodSvc) {
	$scope.activityCtrl = {
		activity: {},
		activityApi: {}
	};

	$scope.contactDetailTypeGroups = [
		{
			type: 'phone',
			label: 'Phone'
		},
		{
			type: 'email',
			label: 'Email'
		},
		{
			type: 'web',
			label: 'Web'
		}
	];

	// updating or creating
	$scope.action = $state.current.name == 'main.crm.customer.index.view.update' ? 'updating' : ($state.current.name == 'main.crm.enquiry.index.view.convert' ? 'converting' : 'creating');
	// blank customer
	$scope.customer = {
		alias: '',
		customer_type: {
			id: 1 // 'Customer'
		},
		customer_status: {
			id: 1 // 'Pending'
		},
		primary_contact: {
			alias: '',
			contact_details: [],
			primary: true
		},
		primary_site: {
			address_1: '',
			address_2: '',
			address_3: '',
			city: '',
			county: '',
			postcode: '',
			key_no: '',
			primary: true,
			same_billing_address: false
		},
		opt_in: false,
		payment_terms: 0,
		customer_initiative: {},
		sales_pipeline: {
			percentage: 0,
			annual_forecast: 0
		}
	};

	$scope.reactivateDateConfig = angular.copy($scope.config.datePicker.basic);
	$scope.reactivateDateConfig.options.minDate = moment(); // today

	// need to load base record first so that we can pass certain parameters to options services
	var basePromises = {};
	if ($scope.action == 'converting') {
		basePromises.enquiry = EnquirySvc.read($state.params.enquiryId);
	}
	else if ($scope.action == 'updating') {
		basePromises.customer = CustomerSvc.read($state.params.customerId);
		// basePromises.mmJobs = MMJobSvc.jobsByCustomer($state.params.customerId);
		basePromises.tgJobs = TGJobSvc.jobsByCustomer($state.params.customerId);
	}

	$scope.loading = true;
	$scope.processing = false;

	$q.all(basePromises).then(function (baseResponses) {
		// get options
		var savedCustomerGroupIds = [];
		if (angular.isDefined(baseResponses.customer)) {
			angular.forEach(baseResponses.customer.data.customer.customer_groups, function (value) {
				savedCustomerGroupIds.push(value.id);
				console.log(value);
				if (value.customer_group === 'Opted In') {
					angular.extend($scope.customer, {
						opt_in: true
					});
					console.log($scope.customer);
				}
			});
		}
		var customerGroupParams = {
			filter: {
				savedCustomerGroups: savedCustomerGroupIds
			}
		};

		var optionPromises = {
			customerTypeOptions: CustomerTypeSvc.options(),
			customerStatusOptions: CustomerStatusSvc.options(),
			titleOptions: FormOptionsSvc.title(),
			contactDetailTypeOptions: ContactDetailTypeSvc.options(),
			paymentTermOptions: CustomerSvc.paymentTermOptions(),
			customerGroupOptions: CustomerGroupSvc.options(customerGroupParams),
			licenseOptions: LicenseOptionsSvc.license(),
			mmCustomerInactiveReasonOptions: MMCustomerInactiveReasonSvc.options(),
			tgCancelReasonOptions: TGCancelReasonSvc.options(),
			invoiceDeliveryMethodOptions: InvoiceDeliveryMethodSvc.options()
		};

		$q.all(optionPromises).then(function (responses) {
			$scope.customerTypeOptions = responses.customerTypeOptions.data.options;
			// set base model on scope
			if ($scope.action == 'converting') {
				$scope.enquiry = $scope.customer.enquiry = angular.copy(baseResponses.enquiry.data.enquiry);
				// merge enquiry into customer
				angular.extend($scope.customer, angular.copy($scope.enquiry));

				angular.extend($scope.customer.primary_contact, {
					title: $scope.enquiry.title,
					fname: $scope.enquiry.first_name,
					lname: $scope.enquiry.last_name
				});
				if ($scope.enquiry.company_name) {
					angular.extend($scope.customer, {
						name: $scope.enquiry.company_name,
						customer_type: $scope.customerTypeOptions[1],
					});
				}
				if ($scope.enquiry.telephone) {
					$scope.customer.primary_contact.contact_details.push({
						value: $scope.enquiry.telephone,
						contact_detail_type: angular.copy($scope.enquiry.telephone_type)
					});
				}
				if($scope.enquiry.sales_pipeline){
                    $scope.customer.sales_pipeline = $scope.enquiry.sales_pipeline;
				}
				if ($scope.enquiry.telephone2) {
					$scope.customer.primary_contact.contact_details.push({
						value: $scope.enquiry.telephone2,
						contact_detail_type: angular.copy($scope.enquiry.telephone_type2)
					});
				}
				if ($scope.enquiry.email) {
					$scope.customer.primary_contact.contact_details.push({
						value: $scope.enquiry.email,
						contact_detail_type: angular.copy($scope.enquiry.email_type)
					});
				}
				if ($scope.enquiry.email2) {
					$scope.customer.primary_contact.contact_details.push({
						value: $scope.enquiry.email2,
						contact_detail_type: angular.copy($scope.enquiry.email_type2)
					});
				}
				if($scope.enquiry.sales_pipeline) {
					$scope.customer.sales_pipeline = $scope.enquiry.sales_pipeline;
				}
				angular.extend($scope.customer.primary_site, {
					address_1: $scope.enquiry.address_line_1,
					address_2: $scope.enquiry.address_line_2,
					address_3: $scope.enquiry.address_line_3,
					city: $scope.enquiry.city,
					county: $scope.enquiry.county,
					postcode: $scope.enquiry.postcode,
					same_billing_address: true,
					billing_address_1: $scope.enquiry.address_line_1,
					billing_address_2: $scope.enquiry.address_line_2,
					billing_address_3: $scope.enquiry.address_line_3,
					billing_city: $scope.enquiry.city,
					billing_county: $scope.enquiry.county,
					billing_postcode: $scope.enquiry.postcode
				});
				angular.extend($scope.customer.customer_initiative, {
					campaign: angular.copy($scope.enquiry.campaign),
					initiative: angular.copy($scope.enquiry.initiative),
					marketing_scheme: angular.copy($scope.enquiry.marketing_scheme),
				});
			}
			else if ($scope.action == 'updating') {
				angular.extend($scope.customer, baseResponses.customer.data.customer);
				// $scope.customer.mm_jobs = baseResponses.mmJobs.data.mm_job_collection;
				$scope.customer.tg_jobs = baseResponses.tgJobs.data.tg_job_collection;
			}
			if ($scope.customer.primary_site && $scope.customer.primary_site.key_no) {
				$scope.customer.primary_site.use_key_no = true;
			}
			if(!$scope.customer.salesPipeline) {
				$scope.customer.salesPipeline = {
					"percentage": 0,
					"annual_forecast": 0,
				};
			}
			// Set options
			$scope.customerTypeOptions = responses.customerTypeOptions.data.options;
			$scope.customerStatusOptions = responses.customerStatusOptions.data.options;
			$scope.titleOptions = responses.titleOptions.data.options;
			$scope.contactDetailTypeOptions = responses.contactDetailTypeOptions.data.options;
			$scope.paymentTermOptions = responses.paymentTermOptions.data.options;
			$scope.customerGroupOptions = responses.customerGroupOptions.data.options;
			$scope.licenseOptions = responses.licenseOptions.data.options;
			if ($scope.action != 'updating' && $scope.licenseOptions.length == 1) {
				$scope.customer.license = $scope.licenseOptions[0];
			}
			$scope.mmCustomerInactiveReasonOptions = responses.mmCustomerInactiveReasonOptions.data.options;
			$scope.tgCancelReasonOptions = responses.tgCancelReasonOptions.data.options;
			$scope.invoiceDeliveryMethodOptions = responses.invoiceDeliveryMethodOptions.data.options;
			if ($scope.action === 'updating') {
				$scope.checkPostcode();
			}
			$scope.loading = false;
		});

	});

	$scope.addContactDetail = function (group) {
		// find and apply the first contact detail type of group
		var labelFilter;
		switch(group) {
			case "phone":
				labelFilter = 'mobile';
				break;
			case "email":
				labelFilter = 'home';
				break;
			case "web":
				labelFilter = 'business';
				break;
		}
		$scope.customer.primary_contact.contact_details.push({
			contact_detail_type: $filter('filter')($scope.contactDetailTypeOptions, {group: group, value: labelFilter})[0]
		});
	};

	$scope.removeContactDetail = function (contactDetail) {
		if (contactDetail.id) {
			contactDetail.delete = true;
		}
		else {
			var index = $scope.customer.primary_contact.contact_details.indexOf(contactDetail);
			$scope.customer.primary_contact.contact_details.splice(index, 1);
		}
	};

	$scope.addressLookup = function(type) {
		if (type === 'primary') {
			return SiteSvc.lookup({postcode: $scope.customer.primary_site.postcode_lookup, houseNo: $scope.customer.primary_site.houseno_lookup}).then(function(response) {
				$scope.primarySiteAddressList = response.data.addresses;
				if ($scope.primarySiteAddressList.length === 1) {
					let address = $scope.primarySiteAddressList[0];
					$scope.customer.primary_site.address_1 = address.line_1 || '';
					$scope.customer.primary_site.address_2 = address.line_2 || '';
					$scope.customer.primary_site.address_3 = address.line_3 || '';
					$scope.customer.primary_site.city = address.city || '';
					$scope.customer.primary_site.county = address.county || '';
					$scope.customer.primary_site.postcode = address.postcode || '';
					$scope.customer.primary_site.showLookup = false;
					$scope.checkPostcode();
				}
			}, function() {
				notify({
					message: 'Address not found',
					classes: 'error',
				});
			});
		}
		else if (type === 'billing') {
			return SiteSvc.lookup({postcode: $scope.customer.primary_site.postcode_billing_lookup, houseNo: $scope.customer.primary_site.houseno_billing_lookup}).then(function(response) {
				$scope.billingSiteAddressList = response.data.addresses;
				if ($scope.billingSiteAddressList.length === 1) {
					let address = $scope.billingSiteAddressList[0];
					$scope.customer.primary_site.site_billing_address_1 = address.line_1 || '';
					$scope.customer.primary_site.site_billing_address_2 = address.line_2 || '';
					$scope.customer.primary_site.site_billing_address_3 = address.line_3 || '';
					$scope.customer.primary_site.billing_city = address.city || '';
					$scope.customer.primary_site.billing_county = address.county || '';
					$scope.customer.primary_site.billing_postcode = address.postcode || '';
					$scope.customer.primary_site.showBillingLookup = false;
				}
			}, function() {
				notify({
					message: 'Address not found',
					classes: 'error',
				});
			});
		}
	};

	$scope.addressChanged = function(address, type) {
		if (type === 'primary') {
			$scope.customer.primary_site.address_1 = address.line_1 || '';
			$scope.customer.primary_site.address_2 = address.line_2 || '';
			$scope.customer.primary_site.address_3 = address.line_3 || '';
			$scope.customer.primary_site.city = address.city || '';
			$scope.customer.primary_site.county = address.county || '';
			$scope.customer.primary_site.postcode = address.postcode || '';
			$scope.customer.primary_site.showLookup = false;
			$scope.checkPostcode();
		}
		else if (type === 'billing') {
			$scope.customer.primary_site.billing_address_1 = address.line_1 || '';
			$scope.customer.primary_site.billing_address_2 = address.line_2 || '';
			$scope.customer.primary_site.billing_address_3 = address.line_3 || '';
			$scope.customer.primary_site.billing_city = address.city || '';
			$scope.customer.primary_site.billing_county = address.county || '';
			$scope.customer.primary_site.billing_postcode = address.postcode || '';
			$scope.customer.primary_site.showBillingLookup = false;
		}
	};

	$scope.formvalidatorconfig = {
		submitHandler: function () {
			// join the activity to the customer if it was filled in
			if (angular.isObject($scope.activityCtrl.activityApi) && $scope.activityCtrl.activityApi.isActivityFilled() === true) {
                angular.extend($scope.customer, {
                    activity: angular.extend({}, $scope.activityCtrl.activity, {
                        activity_start_date: $scope.activityCtrl.activity.activity_start_date.format('YYYY-MM-DD HH:mm:ss'),
                        activity_end_date: $scope.activityCtrl.activity.activity_end_date.format('YYYY-MM-DD HH:mm:ss')
                    })
                });
			}
			$scope.processing = true;

			if ($scope.customer.primary_site.use_key_no !== true) {
				$scope.customer.primary_site.key_no = '';
			}

			var savePromise = $scope.action == 'updating' ? CustomerSvc.update($scope.customer.id, $scope.customer) : ($scope.action == 'converting' ? EnquirySvc.convert($scope.enquiry.id, $scope.customer) : CustomerSvc.create($scope.customer));

			savePromise
				.then(function (response) {

					$scope.customer = response.data.customer;
					notify({
						message: $scope.action == 'updating' ? 'Customer updated successfully' : ($scope.action == 'converting' ? 'Enquiry converted successfully' : 'Customer created successfully')
					});
					$state.go('main.crm.customer.index.view', {
						customerId: $scope.customer.id
					});
				}, function (error) {
					$scope.errors = error;
				})
				.finally(function () {
					$scope.processing = false;
				});
		},
		errorPlacement: function (error) {
			error.appendTo('#customer-errors');
		},
		errorContainer: '#customer-errors'
	};


	$scope.licenseChanged = function() {
		$scope.checkPostcode();
	};
	/*
		Checks for duplicate postcode and it's geographic restriction
	 */
	$scope.checkPostcode = function () {
		if (angular.isObject($scope.customer.primary_site)) {
			$scope.postcodeOutOfArea = false; // reset
			var promises = {
				duplicate: CustomerSvc.duplicateCheck($scope.customer),
				geographicRestriction: CustomerSvc.geographicalCheck($scope.customer, $scope.customer.license)
			};

			$q.all(promises)
				.then(function (responses) {
					$scope.isDuplicate = responses.duplicate.data.isDuplicate;
					if ($scope.isDuplicate === true) {
						$uiViewScroll(angular.element('#duplicate-customer-container'));
					}

					$scope.postcodeOutOfArea = !responses.geographicRestriction.data.restrictionPassed;

				});
		}
	};

	$scope.customerStatusChanged = function (customerStatus) {
		if (angular.isObject(customerStatus) && customerStatus.id === 4) {
			if ($scope.isMM()) {
				$ngBootbox.alert("Setting the status to 'inactive' will cancel all future cleans on jobs associated with this customer (except custom and pre-invoiced cleans)!");
			}
			else if ($scope.isTG()){
				$ngBootbox.alert("Setting the status to 'inactive' will cancel all future visits on jobs associated with this customer!");
			}
		}
	};

	$scope.mmCustomerInactiveReasonChanged = function (mmCustomerInactiveReason) {
		if ((angular.isObject(mmCustomerInactiveReason) && mmCustomerInactiveReason.id === 11) === false) {
			$scope.customer.mm_customer_inactive_reason_description = '';
		}
	};

	$scope.cancelReasonChanged = function (cancelReason) {
		if ((angular.isObject(cancelReason) && cancelReason.id === 7) === false) {
			$scope.customer.cancel_reason_description = '';
		}
	};

	$scope.customerGroupOptionCheckDisabled = function(option) {
		if (option.customer_group === 'Opted In' || option.customer_group === 'Opted Out') {
			return true;
		}
		else {
			return false;
		}
	}

});
